/*
 * fn: buildRec
 *
 * Builds a rec object from input
 *
 */
import { type CardIdType } from '@/defs/card'
import { type DistributiveOmit } from '@/defs/misc'
import { type RecRefType, type RecType } from '@/defs/rec'
import { compareCardRefs, getCardRef } from '@/utils/cardUtil'

type IdProps =
  | { cardId: CardIdType; collectorNumber?: never; set?: never; slug?: never }
  | { cardId?: never; collectorNumber?: string; set?: string; slug?: string }

type Props = { name: string } & IdProps & DistributiveOmit<RecType, 'name' | 'cardId'>

export const buildRec = ({ collectorNumber, name, set, slug, ...props }: Props): RecType => {
  const cardId = props.cardId || getCardRef({ collectorNumber, name, set, slug }).cardId
  const { cardId: _, partnerRef, ...rest } = props

  if (!partnerRef) return { ...rest, cardId, name }

  const { scryfallId, ...shared } = rest
  const cardRef: RecRefType = { cardId, name, scryfallId }
  const [front, back] = compareCardRefs(cardRef, partnerRef) <= 0 ? [cardRef, partnerRef] : [partnerRef, cardRef]

  return { ...shared, ...front, partnerRef: back }
}
